import React, { MutableRefObject } from 'react';
import { VirtualListWrapperProps } from './types';
import { useVirtual } from 'react-virtual';

const VirtualListWrapper = (props: VirtualListWrapperProps) => {
	const { count, estimateSize, itemRender } = props;

	const scrollElement = React.useRef() as MutableRefObject<HTMLDivElement>;

	const rowVirtualizer = useVirtual({
		size: count,
		parentRef: scrollElement,
		estimateSize,

		// 30 is just for testing,to render more items
		// 15 is for runtime, less than for testing, but little more than number of items to fit in dropdown area
		overscan: process.env.NODE_ENV === 'test' ? 30 : 15
	});

	return (
		<div className="w-100 h-100 overflow-auto" ref={scrollElement}>
			<div className="w-100 position-relative" style={{ height: rowVirtualizer.totalSize }}>
				{rowVirtualizer.virtualItems.map(itemRender)}
			</div>
		</div>
	);
};
VirtualListWrapper.displayName = 'VirtualListWrapper';

export default VirtualListWrapper;
